import { InputErrorState } from '~/definitions/standAdmin';
import { getStore } from '~/mobx/AppStore';

const onSubmit = () => {
    const { standAdminStore } = getStore();
    // Reset all errors
    const errors: InputErrorState = {
        coopId: false,
        birthdate: false,
    };

    // Validate fields
    if (standAdminStore.inputChangeState.coopId === '') {
        errors.coopId = true;
    }

    if (standAdminStore.inputChangeState.birthdate === '') {
        errors.birthdate = true;
    }

    standAdminStore.inputErrors = errors;

    if (errors.coopId || errors.birthdate) {
        return;
    }

    const coopId = standAdminStore.inputChangeState.coopId;
    const birthDate = standAdminStore.inputChangeState.birthdate;
    const standAdminRedirectUrl = standAdminStore.standAdminRedirectUrl;

    /**
     * ASVS V6.3.1: Use POST to prevent credentials in URL
     * ASVS V3.5.3: Sensitive operations must use POST, not GET
     */
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = standAdminRedirectUrl;
    form.target = '_blank';

    const params: Record<string, string> = {
        'coop-id': coopId,
        'birth-date': birthDate,
        sid: standAdminStore.sid,
    };

    Object.entries(params).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

export default onSubmit;
